import { ErrorBaseData } from '.'

export const extensionErrors: Record<string, ErrorBaseData> = {
  ExtensionNotFoundException: {
    message: 'Extensão não encontrada',
    description: 'Não foi possível encontrar a extensão. Verifique as informações e tente novamente',
  },
  ExtensionAlreadyUnsubscribedException: {
    message: 'Extensão já desinscrita',
    description: 'Não foi possível se desinscrever desta extensão, pois você já está desinscrito',
  },
  ExtensionSubscriptionRuleNotFoundException: {
    message: 'Erro ao se inscrever na extensão',
    description: 'Verifique as informações e tente novamente',
  },
  ExtensionSubscriptionRuleNotImplementedException: {
    message: 'Erro ao se inscrever na extensão',
    description: 'Verifique as informações e tente novamente',
  },
}
